import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

export const dashboard: RouteRecordRaw = {
  name: 'admin.dashboard',
  path: 'dashboard',
  component: () => import('pages/AlertDashboard.vue'),
  meta: {
    roles: [
      Roles.CenterAdmin,
      Roles.OfficeStaff,
      Roles.OrgAdmin,
      Roles.SuperAdmin,
      Roles.RoomStaff,
    ],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}
